import { useSearchParams } from 'react-router-dom';

export const usePreviewMode = (): boolean => {
  const [searchParams] = useSearchParams();

  return searchParams?.get('preview') === 'true';
};
